import { Color } from '../../../features/shared/styles/Color';

export interface ICheckboxTheme {
	size: string;
	innerSize: string;
	borderRadius: string;
	color?: string;
	active: {
		color?: string;
	};
	disabled: {
		color?: string;
		opacity: string;
		active: {
			color?: string;
		};
	};
}

export const theme: ICheckboxTheme = {
	size: '22px',
	innerSize: '16px',
	borderRadius: '3px',
	color: `${Color.Neutral50}`,
	active: {
		/** Defaults to color.highlight */
		color: undefined,
	},
	disabled: {
		/** Defaults to color.border.default */
		color: undefined,
		opacity: '0.3',
		active: {
			/** Defaults to color.highlight */
			color: undefined,
		},
	},
};
